const routes = [
    {
        name: 'listarIntegracoes',
        path: '/banco_inter/integracoes',
        alias: '/banco_inter/integracoes/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarIntegracao',
        path: '/banco_inter/integracoes/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'editarIntegracao',
        path: '/banco_inter/integracoes/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        name: 'visualizarIntegracao',
        path: '/banco_inter/integracoes/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
]

export default routes
